import React from "react";
import {useFormikContext} from "formik";

import ErrorMessage from "./ErrorMessage";
import {Form} from "react-bootstrap";

function AppFormCheckbox({name, display, label}) {
    const {setFieldTouched, setFieldValue, errors, touched, values} = useFormikContext();
    if (display) {
        if (values[display.name] !== display.value) return <></>
    }

    return (
        <>
            <Form.Check className={"d-flex align-items-center "}>
                <Form.Check.Input className={"big-checkbox"} type={"checkbox"}
                                  label={label}
                                  checked={values[name]}
                                  onBlur={() => setFieldTouched(name)}
                                  onChange={() => setFieldValue(name, !values[name])}/>
                <Form.Check.Label>{label}</Form.Check.Label>

            </Form.Check>
            <ErrorMessage error={errors[name]} visible={touched[name]}/>
        </>
    );
}

export default AppFormCheckbox;
